import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-29d3b899"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "max-w-4xl mx-auto p-6 bg-slate-800 rounded-xl shadow-lg border border-slate-700" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<h2 class=\"text-2xl font-bold mb-6 text-slate-100 flex items-center gap-2\" data-v-29d3b899><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"text-primary-500\" data-v-29d3b899><path d=\"M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z\" data-v-29d3b899></path><polyline points=\"14 2 14 8 20 8\" data-v-29d3b899></polyline><line x1=\"10\" y1=\"13\" x2=\"8\" y2=\"13\" data-v-29d3b899></line><line x1=\"10\" y1=\"17\" x2=\"8\" y2=\"17\" data-v-29d3b899></line><polyline points=\"10 9 9 9 8 9\" data-v-29d3b899></polyline></svg> UUID Generator </h2>", 1)
const _hoisted_3 = { class: "space-y-6" }
const _hoisted_4 = { class: "p-6 bg-slate-900/50 rounded-lg border border-slate-700" }
const _hoisted_5 = { class: "flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-4" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "font-medium text-slate-300" }, "Standard UUID (v4)", -1))
const _hoisted_7 = {
  key: 0,
  class: "flex items-center gap-2"
}
const _hoisted_8 = { class: "flex-1 block w-full p-4 bg-slate-950 rounded-lg font-mono text-primary-300 break-all border border-slate-800" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    x: "9",
    y: "9",
    width: "13",
    height: "13",
    rx: "2",
    ry: "2"
  }),
  /*#__PURE__*/_createElementVNode("path", { d: "M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" })
], -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "p-6 bg-slate-900/50 rounded-lg border border-slate-700" }
const _hoisted_12 = { class: "flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-4" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "font-medium text-slate-300" }, "Short UUID (Segment)", -1))
const _hoisted_14 = {
  key: 0,
  class: "flex items-center gap-2"
}
const _hoisted_15 = { class: "flex-1 block w-full p-4 bg-slate-950 rounded-lg font-mono text-primary-300 break-all border border-slate-800" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    x: "9",
    y: "9",
    width: "13",
    height: "13",
    rx: "2",
    ry: "2"
  }),
  /*#__PURE__*/_createElementVNode("path", { d: "M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" })
], -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = {
  key: 0,
  class: "fixed bottom-8 left-1/2 -translate-x-1/2 bg-slate-900 text-white px-6 py-3 rounded-full shadow-xl border border-slate-700 flex items-center gap-2 z-50"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  class: "text-green-400"
}, [
  /*#__PURE__*/_createElementVNode("polyline", { points: "20 6 9 17 4 12" })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.generateUUID && _ctx.generateUUID(...args))),
            class: "px-4 py-2 bg-primary-600 hover:bg-primary-500 text-white rounded-lg transition-colors text-sm font-medium"
          }, "Generate New")
        ]),
        (_ctx.uuid)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("code", _hoisted_8, _toDisplayString(_ctx.uuid), 1),
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.copyToClipboard(_ctx.uuid))),
                class: "p-4 bg-slate-800 hover:bg-slate-700 text-slate-300 hover:text-white rounded-lg border border-slate-700 transition-colors",
                title: "Copy"
              }, _hoisted_10)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("button", {
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.generateShortUUID && _ctx.generateShortUUID(...args))),
            class: "px-4 py-2 bg-slate-700 hover:bg-slate-600 text-white rounded-lg transition-colors text-sm font-medium"
          }, "Generate New")
        ]),
        (_ctx.shortUuid)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createElementVNode("code", _hoisted_15, _toDisplayString(_ctx.shortUuid), 1),
              _createElementVNode("button", {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.copyToClipboard(_ctx.shortUuid))),
                class: "p-4 bg-slate-800 hover:bg-slate-700 text-slate-300 hover:text-white rounded-lg border border-slate-700 transition-colors",
                title: "Copy"
              }, _hoisted_17)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_Transition, {
      "enter-active-class": "transition ease-out duration-300",
      "enter-from-class": "transform translate-y-4 opacity-0",
      "enter-to-class": "transform translate-y-0 opacity-100",
      "leave-active-class": "transition ease-in duration-200",
      "leave-from-class": "transform translate-y-0 opacity-100",
      "leave-to-class": "transform translate-y-4 opacity-0"
    }, {
      default: _withCtx(() => [
        (_ctx.showSnackbar)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _hoisted_19,
              _createTextVNode(" Copied to clipboard! ")
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}